import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const EmbedConfigPanel = ({ 
  config, 
  onConfigChange 
}) => {
  const handleToggle = (key) => {
    onConfigChange({ ...config, [key]: !config?.[key] });
  };

  const handleSelectChange = (key, value) => {
    onConfigChange({ ...config, [key]: value });
  };

  const loadingOptions = [
    { value: 'eager', label: 'Eager (Load immediately)' },
    { value: 'lazy', label: 'Lazy (Load when visible)' },
    { value: 'defer', label: 'Defer (Load after page)' }
  ];

  const positionOptions = [
    { value: 'inline', label: 'Inline' },
    { value: 'popup', label: 'Popup' },
    { value: 'slide-in', label: 'Slide-in' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-base font-heading font-semibold text-foreground mb-4">
          Embedding Behavior
        </h3>
        <div className="space-y-3">
          <Checkbox
            label="Auto-resize to content"
            description="Automatically adjust height based on form content"
            checked={config?.autoResize}
            onChange={() => handleToggle('autoResize')}
          />
          <Checkbox
            label="CSS isolation mode"
            description="Prevent style conflicts with parent page"
            checked={config?.cssIsolation}
            onChange={() => handleToggle('cssIsolation')}
          />
          <Checkbox
            label="Enable lazy loading"
            description="Load form only when visible in viewport"
            checked={config?.lazyLoad}
            onChange={() => handleToggle('lazyLoad')}
          />
        </div>
      </div>
      <div>
        <Select
          label="Loading strategy"
          description="Choose when the form should load"
          options={loadingOptions}
          value={config?.loadingStrategy}
          onChange={(value) => handleSelectChange('loadingStrategy', value)}
        />
      </div>
      <div>
        <Select
          label="Display position"
          description="How the form appears on the page"
          options={positionOptions}
          value={config?.position}
          onChange={(value) => handleSelectChange('position', value)}
        />
      </div>
      <div>
        <h3 className="text-base font-heading font-semibold text-foreground mb-4">
          Performance
        </h3>
        <div className="space-y-3">
          <Checkbox
            label="Enable CDN delivery"
            description="Serve form assets from global CDN"
            checked={config?.cdnEnabled}
            onChange={() => handleToggle('cdnEnabled')}
          />
          <Checkbox
            label="Cache form data"
            description="Cache form structure for faster loading"
            checked={config?.cacheEnabled}
            onChange={() => handleToggle('cacheEnabled')}
          />
        </div>
      </div>
      <div className="p-4 bg-muted rounded-md">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground">
              Configuration Tips
            </p>
            <p className="text-sm text-muted-foreground mt-1">
              Enable CSS isolation if you experience styling conflicts. Use lazy loading for forms below the fold to improve page speed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmbedConfigPanel;